import {
	Box,
	Button,
	Container,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Link,
	Paper,
	Stack,
	Typography,
	styled,
} from '@mui/material';
import React, { FC, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetchFoerderProgrammDetail } from '../../../../hooks/FetchFoerderProgramm';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import { get } from 'lodash';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import EditIcon from '@mui/icons-material/Edit';
import Grid from '@mui/material/Unstable_Grid2/Grid2';

import { getLocalstorageToken } from '../../../../context/AuthHelper';
import { PostRecord } from '../../../../lib/api/PostRecord';
import { APIS } from '../../../../lib/constants/apis';
import { useFetchOrganisationDetails } from '../../../../hooks/FetchOrganisation';

import Schema from '../../../../lib/paths/foerderprogramm_DETAILS_SEITE_Paths.json';
import OrgaSchema from '../../../../lib/paths/organisation_FULL_Paths.json';
import PersonSchema from '../../../../lib/paths/person_FULL_Paths.json';
const P = Schema.attributes;
const ORGA_P = OrgaSchema.attributes;
const PERSON_P = PersonSchema.attributes;

const StyledPaper = styled(Paper)({
	padding: '2rem',
});
// Set defaultProps
StyledPaper.defaultProps = {
	elevation: 0,
};
const FoerderProgrammDetails: FC<{}> = () => {
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();
	const numericId = id ? parseInt(id) : -1;
	const { loading, data, error } = useFetchFoerderProgrammDetail(numericId);
	const { data: orgaData } = useFetchOrganisationDetails(get(getLocalstorageToken(), 'organisationId'));

	const [openDialog, setOpenDialog] = useState(false);

	const handleCreateApplication = async () => {
		try {
			const appData = {
				Foerderprogramm: numericId,
				Allgemein_Anwendung: 'Foerdermittelvergabe',
				Antragsstatus_Antragsstatus: 'inBearbeitung',
				Allgemein_Typ: 'Zuwendungsantrag',
				Allgemein_Antragsart: 'Erstantrag',
				Antragsteller: 'Organisation',
				AN_Organisation: get(getLocalstorageToken(), 'organisationId'),
				Antragstellerin_Name: get(orgaData, ORGA_P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path),
				Antragstellerin_Strasse_Hausnummer: get(orgaData, ORGA_P.Adressdaten_Strasse_Und_Hausnummer.path),
				Antragstellerin_PLZ: get(orgaData, ORGA_P.Adressdaten_PLZ.path),
				Antragstellerin_Ort: get(orgaData, ORGA_P.Adressdaten_Ort.path),
			};
			let res = await PostRecord(APIS.Zuwendungsantrag, { data: appData });
			if (res) navigate(`/meine-antraege/foerderung-uebersicht/${get(res, 'data.id')}`);
		} catch (err: any) {
			console.error('ERROR: Creating Application ', err);
		}
	};

	if (error) {
		console.log(' error ', error);
	}

	console.log(' ata ', data);
	if (loading) return <LoadingBackdrop />;
	return (
		<>
			<Container>
				<Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
					<DialogTitle>Förderung beantragen</DialogTitle>
					<DialogContent>Wenn Sie fortfahren, beantragen Sie eine Förderung im ausgewählten Förderprogramm</DialogContent>
					<DialogActions>
						<Button variant="outlined" onClick={() => setOpenDialog(false)}>
							{' '}
							Abbrechen
						</Button>
						<Button onClick={handleCreateApplication}> Fortfahren</Button>
					</DialogActions>
				</Dialog>
				<Stack spacing={3}>
					<Stack direction={'row'} justifyContent={'flex-start'}>
						<Button variant={'outlined'} startIcon={<KeyboardArrowLeftIcon />} onClick={() => navigate('/foerderprogramm')}>
							Zurück
						</Button>
					</Stack>
					<Typography variant="h1"> {get(data, P.Allgemein_Name.path, '')}</Typography>
					<Grid container columns={6} spacing={3}>
						<Grid xs={6} md={4}>
							<StyledPaper>
								<Stack spacing={6}>
									<Typography component={'div'}>
										<div dangerouslySetInnerHTML={{ __html: get(data, P.Allgemein_Beschreibung.path, '') }}></div>
									</Typography>

									<Box>
										<Typography variant="h5">Ziel der Förderung</Typography>
										<br />
										<Typography component={'div'}>
											<div
												dangerouslySetInnerHTML={{ __html: get(data, P.Allgemein_Ziel_Der_Foerderung.path, '') }}
											></div>
										</Typography>
									</Box>
								</Stack>
							</StyledPaper>
							<Stack direction={'row'} justifyContent={'center'} sx={{ width: '100%', mt: 3 }}>
								<Button endIcon={<EditIcon />} onClick={() => setOpenDialog(true)} sx={{ marginLeft: 'auto' }}>
									Förderung beantragen
								</Button>
							</Stack>
						</Grid>
						<Grid xs={6} md={2}>
							<Stack spacing={3}>
								<StyledPaper>
									<Typography>Fördermittelgeber</Typography>
									<Box sx={{ mt: '1rem' }}>
										<Typography>
											{get(
												data,
												P.Projekttraeger.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path,
											)}
										</Typography>
										<Typography>{ }</Typography>
										<Typography>
											{get(data, P.Projekttraeger.schema.attributes.Adressdaten_Strasse_Und_Hausnummer.path)}
										</Typography>
										<Typography>
											{get(data, P.Projekttraeger.schema.attributes.Adressdaten_PLZ.path) +
												' ' +
												get(data, P.Projekttraeger.schema.attributes.Adressdaten_Ort.path)}
										</Typography>
									</Box>
								</StyledPaper>
								{get(data, P.Ansprechpartner.path, []).length > 0 && (
									<StyledPaper>
										<Typography>Ansprechpartner</Typography>
										{get(data, P.Ansprechpartner.path, []).map((ele: any, i: number) => (
											<Box key={i} sx={{ mt: '1rem' }}>
												<Typography>
													{get(ele, PERSON_P.Personenbezogene_Daten_Vorname.path)}{' '}
													{get(ele, PERSON_P.Personenbezogene_Daten_Nachname.path)}
												</Typography>
												<Typography>{get(ele, PERSON_P.Kontaktdaten_Telefon.path)}</Typography>
												<Typography>
													<Link href={'mailto:' + get(ele, PERSON_P.Kontaktdaten_E_Mail.path)}>
														{get(ele, PERSON_P.Kontaktdaten_E_Mail.path)}
													</Link>
												</Typography>
											</Box>
										))}
									</StyledPaper>
								)}
							</Stack>
						</Grid>
					</Grid>
				</Stack>
			</Container>
		</>
	);
};
export default FoerderProgrammDetails;